var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { useRouter } from "vue-router/composables";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import localize from "@/utils/localization";
import { fetchObjectStoreContentsSizeSummary } from "./service";
import { buildTopNDatasetsBySizeData, byteFormattingForChart, useDataLoading, useDatasetsToDisplay } from "./util";
import BarChart from "./Charts/BarChart.vue";
import OverviewPage from "./OverviewPage.vue";
import RecoverableItemSizeTooltip from "./RecoverableItemSizeTooltip.vue";
import SelectedItemActions from "./SelectedItemActions.vue";
import WarnDeletedDatasets from "./WarnDeletedDatasets.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreStorageOverview',
    props: {
        objectStoreId: null
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const { getObjectStoreNameById } = useObjectStoreStore();
        const { numberOfDatasetsToDisplayOptions, numberOfDatasetsToDisplay, numberOfDatasetsLimit, datasetsSizeSummaryMap, topNDatasetsBySizeData, isRecoverableDataPoint, onUndeleteDataset, onPermanentlyDeleteDataset, } = useDatasetsToDisplay();
        const { isLoading, loadDataOnMount } = useDataLoading();
        loadDataOnMount(() => __awaiter(this, void 0, void 0, function* () {
            const allDatasetsInObjectStoreSizeSummary = yield fetchObjectStoreContentsSizeSummary(props.objectStoreId, numberOfDatasetsLimit);
            allDatasetsInObjectStoreSizeSummary.forEach((dataset) => datasetsSizeSummaryMap.set(dataset.id, dataset));
            buildGraphsData();
        }));
        function buildGraphsData() {
            const allDatasetsInObjectStoreSizeSummary = Array.from(datasetsSizeSummaryMap.values());
            topNDatasetsBySizeData.value = buildTopNDatasetsBySizeData(allDatasetsInObjectStoreSizeSummary, numberOfDatasetsToDisplay.value);
        }
        function onViewDataset(datasetId) {
            return __awaiter(this, void 0, void 0, function* () {
                router.push({
                    name: "DatasetDetails",
                    params: {
                        datasetId: datasetId,
                    },
                });
            });
        }
        function onPermDelete(datasetId) {
            onPermanentlyDeleteDataset(buildGraphsData, datasetId);
        }
        function onUndelete(datasetId) {
            onUndeleteDataset(buildGraphsData, datasetId);
        }
        return { __sfc: true, props, router, getObjectStoreNameById, numberOfDatasetsToDisplayOptions, numberOfDatasetsToDisplay, numberOfDatasetsLimit, datasetsSizeSummaryMap, topNDatasetsBySizeData, isRecoverableDataPoint, onUndeleteDataset, onPermanentlyDeleteDataset, isLoading, loadDataOnMount, buildGraphsData, onViewDataset, onPermDelete, onUndelete, localize, byteFormattingForChart, BarChart, OverviewPage, RecoverableItemSizeTooltip, SelectedItemActions, WarnDeletedDatasets, LoadingSpan };
    }
});
